module.exports = __webpack_public_path__ + "static/media/electricity.f845cbe9.svg";